// src/utils/authErrorMessage.js
//
// Mapea códigos de error de Firebase Auth a mensajes en español.
// Reutilizado por el registro (register/index.jsx) y el login (userActions.jsx).

const AUTH_ERROR_MESSAGES = {
  "auth/email-already-in-use": "El correo ya está asociado a una cuenta activa",
  "auth/invalid-email": "Correo no válido",
  "auth/weak-password": "Contraseña insegura",
  "auth/too-many-requests": "Demasiados intentos, espera unos minutos",
  "auth/network-request-failed": "Sin conexión, intenta de nuevo",
  "auth/user-disabled": "Esta cuenta está deshabilitada",
  // En login no revelamos cuál de los dos falló:
  "auth/wrong-password": "Correo o contraseña incorrectos",
  "auth/user-not-found": "Correo o contraseña incorrectos",
  "auth/invalid-credential": "Correo o contraseña incorrectos",
};

const DEFAULT_AUTH_ERROR = "Ocurrió un error, intenta de nuevo";

export function authErrorMessage(error) {
  return AUTH_ERROR_MESSAGES[error?.code] || DEFAULT_AUTH_ERROR;
}
